import { render, staticRenderFns } from "./RoleCrud.vue?vue&type=template&id=a0e1841a&scoped=true&"
import script from "./RoleCrud.vue?vue&type=script&lang=js&"
export * from "./RoleCrud.vue?vue&type=script&lang=js&"
import style0 from "./RoleCrud.vue?vue&type=style&index=0&id=a0e1841a&prod&scoped=true&lang=css&"
import style1 from "./RoleCrud.vue?vue&type=style&index=1&id=a0e1841a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e1841a",
  null
  
)

export default component.exports